<script setup lang="ts">
// Imports
import DynamicDialog from 'primevue/dynamicdialog'

useHead({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] })

// Stores
const commerceStore = useCommerceStore()
const businessStore = useBusinessStore()
const { businessId } = storeToRefs(businessStore)

// Side effects
// Initialize commerce store with business ID from store
if (businessId.value) {
  commerceStore.initStore(businessId.value)
}
</script>

<template>
  <div class="flex min-h-screen flex-col bg-gray-100 print:min-h-0">
    <div class="head">
      <DynamicDialog />
      <Toast />
      <PublicStoreHeader />
    </div>
    <div class="main-content container mx-auto my-4 flex-1 px-2 print:my-0 print:w-full print:max-w-full print:px-0">
      <slot />
      <PublicStoreProductsModal />
    </div>
  </div>
</template>
